<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listfiscalNature"
        :title-table="$t('Fiscal Nature')"
        module="fiscalNatureSettingsModule"
        sort-name="nome"
        :show-btn-add="verificarPermissao('ROLE_ADMIM_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_ADMIM_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <FormFiscalNature v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormFiscalNature from './forms/FormFiscalNature.vue'
import { verificarPermissao } from '@/auth/utils'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormFiscalNature
  },
  computed: {
    ...mapState('fiscalNatureSettingsModule', {
      listfiscalNature: (state) => state.listfiscalNature
    })
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id'
        },
        {
          label: 'Descrição',
          field: 'nome'
        },
        {
          label: 'Ativo',
          field: 'ativo'
        },
        {
          label: 'Action',
          field: 'action'
        }
      ],
      pageConfig: {
        page: 1,
        size: 10,
        sort: 'nome',
        order: 'asc'
      }
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'fiscalNatureSettingsModule/prepareToEditFiscalNature',
        data
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    }
  }
}
</script>
